
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import Box from "ui/atom/Box";
import Button from "ui/base/Button";
import List from "ui/base/List";


Features.Item = ({ head, title, description, list, action }) => {
	const theme = useTheme();

	const style = {
		root: {
			flex: { sm: "1 1 300px" },
			borderRadius: "8px",
			p: "1px",
			backgroundImage: "linear-gradient(230deg, #A848FF 0%, #FC4E0F 100%)",
			boxShadow: "0px 0px 33.308px 0px rgba(252, 78, 15, 0.15)"
		},
		content: {
			width: "100%",
			p: theme.spacing(4.25, 3, 2.5),
			borderRadius: "7px",
			borderWidth: "4px",
			background: "#1A1B37",
			zIndex: 0
		},
		button: {
			mt: theme.spacing(1)
		}
	};

	return (
		<Box sx={style.root}>
			<Box.Column gap={1} sx={style.content}>
				<Typography variant="body1" color="text.secondary">{head}</Typography>
				<Typography variant="h2" fontSize={24}>{title}</Typography>
				{description && <Typography variant="body2" sx={{ mt: 1 }}>{description}</Typography>}
				{list && (
					<List dense>
						{list.map((i, k) => <List.Item key={k}>{i}</List.Item>)}
					</List>
				)}
				{action && <Button variant="contained" color="secondary" onClick={action.onClick} sx={style.button}>{action.label}</Button>}
			</Box.Column>
		</Box>
	);
};

export default function Features({ title, features }) {
	const style = {
		root: {
			alignItems: "center",
			justifyContent: "center"
		},
		title: {
			textAlign: "center",
			mx: "auto",
			"b": {
				background: "linear-gradient(90deg, #FFF -50%, #B86AFF 100%)",
				backgroundClip: "text",
				color: "transparent"
			}
		},
		features: {
			width: "100%",
			flexWrap: "wrap",
			flexDirection: { xs: "column", sm: "row" }
		}
	};

	return (
		<Box.Column gap={3} sx={style.root}>
			<Typography variant="h1" fontSize={32} sx={style.title}>{title}</Typography>
			<Box gap={2} sx={style.features}>
				{features?.map((feature, index) => <Features.Item {...feature} key={index} />)}
			</Box>
		</Box.Column>
	);
}